<script>
import appConfig from "@/app.config";
import axios from 'axios';
import VueEasyLightbox from "vue-easy-lightbox";
import MenuBar from './MenuBar.vue'

import { Editor, EditorContent, FloatingMenu } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Text from '@tiptap/extension-text'
import TextStyle from "@tiptap/extension-text-style";
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import Placeholder from '@tiptap/extension-placeholder'
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import Youtube from '@tiptap/extension-youtube'
import Underline from '@tiptap/extension-underline'

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

// 초기세팅
function initialState() {
  return {
    localPage: 0, // prop을 직접 변경하지 않고, data로 복사
    localSearchKeyword: "", // prop에서 받아서 여기에 넣자
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    index: 0,
    lightboximgs: [],
    // 조회수는 모바일에서는 안나오게하자
    fields: [
      {key: 'idx', label: '번호', thClass: 'col-1 text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'subject', label: '글제목', thClass: 'text-center font-size-11', tdClass: 'board-subject text-overflow'},
      {key: 'writer', label: '글쓴이', thClass: 'col-1 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'insert_time', label: '작성일', thClass: 'wx-90 text-center font-size-11', tdClass: ' text-center'},
      {key: 'hit', label: '조회수', thClass: 'col-1 text-center font-size-11', tdClass: 'col-1 text-center'},
    ],
  };
}

export default {
  components: {
    VueEasyLightbox,
  },
  data() {
    return {
      appConfig: appConfig,
      ...initialState(),
    };
  },
  props: {
    bi: {
      type: Number,
    },
    wi: {
      type: Number,
    },
    page: {
      type: Number,
    },
    search: {
      type: Object,
    },
    searchKeyword: {
      type: String,
    },
    baseInfo: {
      type: Object,
    },
    boardInfo: {
      type: Object,
    },
    thisBoard: {
      type: Object,
    },
    tableData: {
      type: Array,
    },
    latestData: {
      type: Array,
    },
    tableDataInfo: {
      type: Object,
    },
  },
  watch: {
    // 라우터 변경 시 metaInfo 업데이트
    $route() {
      this.updateMetaInfo();
    },
    // thisBoard가 변경될 때 metaInfo 업데이트
    thisBoard: {
      handler(newVal) {
        if (newVal) {
          this.updateMetaInfo();
        }
      },
      deep: true,
      immediate: true
    },
    // jsonData가 변경될 때도 감시
    'thisBoard.jsonData': {
      handler(newVal) {
        if (newVal) {
          this.updateMetaInfo();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // 컴포넌트 마운트 시 metaInfo 업데이트
    this.updateMetaInfo();
  },
  created() {
    this.first()
  },
  computed: {
  },
  metaInfo() {
    // 기본값 먼저 설정 (데이터가 없어도 항상 반환)
    let boardName = '게시판';
    
    // 백엔드에서 데이터가 로드되면 업데이트
    if (this.thisBoard && this.thisBoard.jsonData && this.thisBoard.jsonData.name) {
      boardName = this.thisBoard.jsonData.name;
    }
    
    const title = `${boardName} | 대구여성인권센터`;
    const description = `${boardName} 게시판 - 대구여성인권센터`;
    
    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: description
        },
        {
          property: 'og:title',
          content: title
        },
        {
          property: 'og:description',
          content: description
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: title
        },
        {
          name: 'twitter:description',
          content: description
        }
      ]
    };
  },
  methods: {
    // metaInfo 업데이트 메서드
    updateMetaInfo() {
      this.$nextTick(() => {
        // Vue Meta가 있으면 갱신
        if (this.$meta) {
          this.$meta().refresh();
        }
      });
    },
    // 처음에 실행되는 부분
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
      this.localPage = this.page
      this.localSearchKeyword = this.searchKeyword
    },
    thisView(value) {
      // 비밀글게시판이면 관리자 or 비밀글 작성자 확인하는 비밀번호창 나오게하자
      if (this.thisBoard.jsonData.use_secret == true) {
        // 관리자는 바로 이동시키자
        if (this.login.level >= 98) {
          this.$router.push({ path: `/jy/${this.thisBoard.idx}/r/${value.idx}` })
        } else {
          // swal에서 비밀번호 받아오자
          this.$swal.fire({
            title: "비밀글",
            input: "text",
            inputLabel: "비밀번호를 입력해주세요",
            inputPlaceholder: "",
            inputAttributes: {
              minlength: "6",
              autocapitalize: "off",
              autocorrect: "off",
              autocomplete: "off", // 브라우저 자동완성 및 저장 방지
            },
            customClass: {
              input: 'password-field',
            },
            confirmButtonText: "확인",
            validationMessage: "비밀번호는 최소 6글자 이상입니다.",
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.value!==null && result.value!=='') {
                // store에 게시글 읽기한다고 정보전달하자
                this.$store.commit('setBoardSecurity', {
                  "work": 'r',
                  "password": result.value,
                });
                // 읽기페이지 이동
                this.$router.push({ path: `/jy/${this.thisBoard.idx}/r/${value.idx}` })
              }
            }
          });
        }
      } else {
        // 게시판 읽을 권한 있는사람만 router 보내주자
        if (this.login.level >= this.thisBoard.jsonData.lv_see) {
          // store에 게시판번호랑 페이지 번호 보내주자
          this.$store.commit('setNowBoard', {
            "idx": this.thisBoard.idx,
            "page": this.page,
            "work": 'view',
          });
          // 게시물 진입
          this.$router.push({ path: `/jy/${this.thisBoard.idx}/r/${value.idx}` })
        } else {
          this.$notify({ type: 'error', duration: 3000, 'title': '에러', text: "글 읽기 권한이 없습니다." })
        }
      }
    },
    searchBoard() {
      this.$emit('submit-search', this.localSearchKeyword);
      this.localSearchKeyword = ''
    },
    pageClick: function (button, pageNum){
      // `localPage`를 사용하여 변경할 수 있습니다.
      this.localPage = pageNum;
      if (this.localSearchKeyword !=='') {
        this.$router.push({ path: `/jy/${this.bi}/p/0/${pageNum}/${this.localSearchKeyword}` })
      } else {
        this.$router.push({ path: `/jy/${this.bi}/p/0/${pageNum}` })
      }
    },
    thumnailLatest(val) {
      //return `${appConfig.fileserver}/${this.bi}/${val}/thum.jpg?`;
      // 썸네일 이미지 갱신을 위해 현재 시간을 쿼리 파라미터로 추가
      return `${appConfig.fileserver}/${this.bi}/${val}/thum.jpg?`+Date.now();
    },
  },
}
</script>

<template>
  <div v-show="thisBoard" class="row">
    <!-- 게시글 영역 -->
    <div v-if="thisBoard" class="col-lg-9 col-md-12 col-sm-12 mb-4">
      <div v-if="thisBoard.jsonData" class="card">
        <!-- 리본 -->
        <div class="ribbon ribbon-left ribbon-primary overflow-hidden">
          <span class="text-center d-block shadow small h6">
            {{ thisBoard.jsonData.name }}
          </span>
        </div>

        <div class="d-flex align-items-right justify-content-between p-2">
          <div class="">
          </div>

          <!-- 상단 pagination -->
          <div class="">
            <ul class="pagination mb-0">
              <b-pagination
                v-if="search.nowCnt > 0"
                v-model="localPage"
                :total-rows="search.nowCnt"
                :per-page="search.perPage"
                aria-controls="pmListTable"
                @page-click="pageClick"
                limit="6"
              >
                <template #first-text><span class="text-primary">최근</span></template>
                <template #prev-text><span class="text-secondary">이전</span></template>
                <template #next-text><span class="text-secondary">다음</span></template>
                <template #last-text><span class="text-primary">처음</span></template>
                <template #page="{ page, active }">
                  <b v-if="active">{{ page }}</b>
                  <span v-else>{{ page }}</span>
                </template>
              </b-pagination>
            </ul>
          </div>

        </div>
        

        <!-- 텍스트 형식이라면 -->
        <div v-if="thisBoard.jsonData.listtype=='text'" class="p-2">
          <!-- 테이블 -->
          <div class="table-responsive shadow rounded">
            <b-table 
              id="boardTable" 
              ref="boardTable" 
              :fields="fields" 
              :items="tableData" 
              :hover="true"
              table-class=""
              :striped="true"
              show-empty
              class="cursor-pointers"
              @row-clicked="(item) => thisView(item)"
            >
              <!-- 로딩 -->
              <template #table-busy>
                <div class="text-center text-secondary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>로딩중...</strong>
                </div>
              </template>
              <!-- 글 없으면 -->
              <template #empty="scope">
                <div v-if="tableData" class="text-bold text-secondary font-size-13 text-center">
                  게시물이 없습니다.
                </div>
              </template>
              <!-- 번호 (공지글이면 번호대신 공지 글자)-->
              <template #cell(idx)="row">
                <div v-if="row.item.is_notice==1" class="text-bold text-danger bg-soft-warning font-size-11">
                  공지
                </div>
                <div v-else class="text-bold text-secondary font-size-10">
                  {{ row.item.idx }}
                </div>
              </template>
              <!-- 글제목 -->
              <template #cell(subject)="row">
                <div v-if="row.item.is_notice==1" class="text-bold text-danger font-size-13">
                  {{ row.item.subject }}
                </div>
                <!-- 비밀글 게시판 reply  0상담 답변대기 1상담 답변완료 3상담내역파기 --> 
                <div v-else-if="thisBoard.jsonData.use_secret==true" class="">
                  <span v-if="row.item.end==true" class="text-bold text-secondary font-size-13">
                    {{ row.item.insert_time }} 상담종료 (자료파기)
                  </span>
                  <span v-else-if="row.item.reply==true" class="text-bold text-primary font-size-13">
                    {{ row.item.insert_time }} 비밀 상담글 (답변완료)
                    <i class="mdi mdi-lock text-info"></i>
                  </span>
                  <span v-else-if="row.item.reply==false" class="text-bold text-danger font-size-13">
                    {{ row.item.insert_time }} 비밀 상담글
                    <i class="mdi mdi-flower text-danger"></i>
                  </span>
                </div>
                <!-- 일반 게시판 -->
                <div v-else class="text-bold text-dark font-size-13">
                  <div v-if="row.item.is_temp_save == false" class="text-bold text-overflow300">
                    <span class="font-size-13 text-dark">{{ row.item.subject }}</span>
                  </div>
                  <div v-else class="text-bold text-overflow300">
                    <span class="font-size-13 text-danger font-weight-bold">
                      <i class="mdi mdi-file-outline text-info mr-1"></i>임시저장된 게시글입니다.
                    </span>
                  </div>
                </div>
              </template>
              <!-- 글쓴이 -->
              <template #cell(writer)="row">
                <div v-if="thisBoard.jsonData.use_secret==true && row.item.end==true" class="text-bold text-dark font-size-13">
                  상담종료
                </div>
                <div v-else class="text-bold text-blue font-size-11">
                  <i class="mdi mdi-heart text-danger mr-1"></i>
                  <span class="text-dark">{{ row.item.writer }}</span>
                </div>
              </template>
              <!-- 작성일 -->
              <template #cell(insert_time)="row">
                <div class="text-bold text-dark font-size-11">
                  {{ row.item.insert_time }}
                </div>
              </template>
              <!-- 조회수 -->
              <template #cell(hit)="row">
                <div v-if="thisBoard.jsonData.use_secret==true" class="text-bold text-warning font-size-10">
                  *
                </div>
                <div v-else class="text-bold text-info font-size-10">
                  {{ row.item.hit }}
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <!-- 이미지 형식이라면 -->
        <div v-else-if="thisBoard.jsonData.listtype=='image'" class="p-2">
          <div v-if="tableData" class="row">
            <div v-for="(item, index) in tableData" :key="index" class="col-lg-6 col-md-12 mb-4 pb-2">
              <div class="card border-0 shadow cursor-pointers" :class="{'bg-soft-danger': item.is_temp_save == true}">
                <router-link :to="`/jy/${thisBoard.idx}/r/${item.idx}`">

                  <div class="work-container work-modern position-relative position-relative d-block overflow-hidden">
                    <!-- 썸네일 없으면 -->
                    <div v-if="item.is_thum==0" class="gallery-noimg vertical-center text-center border-bottom p-2">
                      <div class="text-center"><i class="mdi mdi-text-box noimg"></i></div>
                      <div class="text-dark h5 text-overflow300 text-center">{{ item.subject }}</div>
                    </div>
                    <!-- 썸네일 있음 -->
                    <div v-else class="gallery-container text-center border-bottom">
                      <img :src="thumnailLatest(item.idx)" class="img-fluid work-image" alt="">
                    </div>
                  </div>

                  <div class="card-body p-2 content">

                    <div v-if="item.is_temp_save == false" class="text-bold text-overflow300">
                      <span class="font-size-13 text-dark">{{ item.subject }}</span>
                    </div>
                    <div v-else class="text-bold text-overflow300">
                      <span class="font-size-13 text-danger font-weight-bold">
                        <i class="mdi mdi-file-outline text-danger mr-1"></i>임시저장 게시글입니다. (관리자만 보여요)
                      </span>
                    </div>

                    <div class="d-flex align-items-right justify-content-between mt-2 mb-2">
                      <div>
                        <div class="font-size-10">
                          <span class="mr-2">
                            <i class="mdi mdi-clock-outline text-muted mr-1"></i>
                            <b class="text-muted">{{ item.insert_time }}</b>
                          </span>
                          <span class="text-secondary comments">
                            <i class="mdi mdi-eye text-info mr-1"></i>
                            <b>{{ item.hit }}</b>
                          </span>
                        </div>
                      </div>
                      <div>
                        <div class="font-size-11">
                          <i class="mdi mdi-heart text-danger mr-1"></i>
                          <b class="text-dark">{{ item.writer }}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
                
              </div>
            </div>
            <div v-if="tableData.length == 0" class="col-12 text-center font-size-13">게시물이 없습니다.</div>
          </div>
        </div>

        <!-- 하단 pagination -->
        <div class="d-flex align-items-right justify-content-between p-2">
          <div class="">           
          </div>
          <div class="">
            <ul class="pagination mb-0">
              <b-pagination
                v-if="search.nowCnt > 0"
                v-model="localPage"
                :total-rows="search.nowCnt"
                :per-page="search.perPage"
                aria-controls="pmListTable"
                @page-click="pageClick"
                limit="6"
              >
                <template #first-text><span class="text-primary">최근</span></template>
                <template #prev-text><span class="text-secondary">이전</span></template>
                <template #next-text><span class="text-secondary">다음</span></template>
                <template #last-text><span class="text-primary">처음</span></template>
                <template #page="{ page, active }">
                  <b v-if="active">{{ page }}</b>
                  <span v-else>{{ page }}</span>
                </template>
              </b-pagination>
            </ul>
          </div>
        </div>
        
      </div>
    </div>
    <!-- 우측 사이드바 시작 -->
    <div v-if="thisBoard.jsonData" class="col-lg-3 col-md-12 col-sm-12 mb-2">
      <div class="card sidebar sticky-bar p-4">
        <div class="">

          <!-- 게시판 메뉴 -->
          <h5 class="widget-title">게시판</h5>
          <ul v-if="boardInfo" class="list-unstyled mb-4">
            <li v-for="(value, key) in boardInfo[thisBoard.jsonData.group]" :key="key" class="cursor-pointer mb-1">
              <router-link :to="`/jy/${value.idx}`" class="accounts d-block text-center unselected-menu rounded text-dark p-2" 
              :class="{'active selected-menu ':thisBoard.jsonData.name == value.contents.name}">
                <span class="title text-dark h6">
                  {{ value.contents.name }}
                </span>
              </router-link>
            </li>
          </ul>

          <!-- 현재 메뉴 -->
          <div class="widtget pt-4 mb-2 pb-2">
            <h5 class="widget-title">{{ thisBoard.jsonData.name }}</h5>
            <div class="font-size-12 mb-1">
              <i class="mdi mdi-blur mr-1"></i>전체게시물: <b class="text-warning">{{ tableDataInfo.allCnt }}</b>
            </div>
            <!-- 검색폼 -->
            <div v-if="thisBoard.jsonData.use_secret==false" class="mt-1">
              <div class="input-group">
                <input
                  name="searchform"
                  id="searchform"
                  type="text"
                  class="form-control form-control-sm"
                  v-model="localSearchKeyword"
                  placeholder="검색어 입력.."
                  required
                  aria-describedby="searchbtn"
                  @keydown.enter.prevent="searchBoard()"
                />
                <div class="input-group-append">
                  <button @click="searchBoard()" class="btn btn-sm btn-info submitBnt" type="submit" id="searchbtn">검색</button>
                </div>
              </div>
            </div>
            <div v-if="login.level >= thisBoard.jsonData.lv_write" class="mt-2">
              <router-link :to="`/jy/${this.thisBoard.idx}/w`">
                <div class="page-link rounded bg-blue text-white text-bold text-center ">
                  <i class="mdi mdi-lead-pencil text-white mr-1"></i>글쓰기
                </div>
              </router-link>
            </div>
          </div>

          <!-- 비밀게시판이면 -->
          <div v-if="thisBoard.jsonData.use_secret==true" class="widget pt-4 mb-4 pb-2">
            <h5 class="widget-title"></h5>
            <div class="mt-1 mb-2">
              <div class="alert bg-light">
                <i class="mdi mdi-lock text-info"></i>
                <span class="text-info">안내</span>
                <div class="font-size-14 text-bold mt-2">
                  <span class="text-purple">상담은 무료로 진행되며, 상담사와 본인만 글 읽기가 가능하며 상담종료 후 게시글은 파기됩니다.</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 최근 게시글 -->
          <div v-if="thisBoard.jsonData.use_latest==true" class="widget pt-4 pb-2">
            <h5 class="widget-title">최근 게시글</h5>            
            <div v-for="(value, key) in latestData" :key="key" class="pt-1 pb-1 border-top clearfix board-recent">
              <router-link :to="`/jy/${thisBoard.idx}/r/${value.idx}`">
                <!-- 썸네일 있으면 이미지처리-->
                <div v-if="value.is_thum == true" class="board-recent-thumb float-left list-latestthum">
                  <img :src="thumnailLatest(value.idx)" alt="img" class="border rounded">
                </div>
                <!-- 썸네일 있으면 제목 -->
                <div v-if="value.is_thum == true" class="board-recent-content float-left">
                  <div class="text-overflow120">
                    <span class="text-bold">{{ value.subject}}</span> 
                  </div>
                  <div class="board-meta d-flex justify-content-between">
                    <span class="text-muted font-size-11">{{ value.insert_time}}</span>
                  </div>
                </div>
                <!-- 썸네일 없으면 제목 -->
                <div v-else class="board-recent-content full float-left">
                  <div class="text-overflow180">
                    <span class="text-bold">{{ value.subject}}</span> 
                  </div>
                  <div class="board-meta d-flex justify-content-between">
                    <span class="text-muted font-size-11">{{ value.insert_time}}</span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>